export const base64 = {
  decode: (s: string) => Uint8Array.from(atob(s), c => c.charCodeAt(0)),
  encode: (b: Uint8Array) => btoa(String.fromCharCode(...new Uint8Array(b))),
  decodeToString: (s: string) => new TextDecoder().decode(base64.decode(s)),
  encodeString: (s: string | undefined) => base64.encode(new TextEncoder().encode(s)),
}
